// constants/layout.ts

/**
 * Layout dimensions used across the app.
 *
 * SINGLE SOURCE OF TRUTH. Do not duplicate these numbers anywhere else.
 *
 * History: previously the mobile footer height was hardcoded as `64` in
 * DashboardLayout, OtcCalculator, and elsewhere — but the actual rendered
 * footer was 76px. That mismatch caused the footer to overlap content
 * across the app on mobile. Fixed by centralizing here.
 */

/** Mobile footer height (the bottom nav bar). Must match MainFooter's height prop. */
export const MOBILE_FOOTER_HEIGHT = 76;

/** Mobile header height (when DashboardLayout's `hasMobileHeader` is true). */
export const MOBILE_HEADER_HEIGHT = 56;

/**
 * Max width of the p2p trading frame (market bar + order book / chart / market
 * grid). Past this the frame stops growing and centers itself with gutters,
 * instead of stretching edge-to-edge on ultrawide monitors.
 *
 * 1536 is the rabex-ui theme's `xxl` breakpoint, not a magic number. The rest of
 * the panel caps at Container maxWidth="lg" (1200) — the trading grid gets the
 * wider cap because it carries three columns side by side.
 */
export const P2P_MAX_CONTENT_WIDTH = 1536;

/** Container vertical reserve — accounts for Container margins and breathing room. */
export const MOBILE_CONTAINER_PAD = 10;

/**
 * z-index of CustomModal's mobile bottom-sheet variant (the `xs` branch). Absurdly
 * large, but it is what the app ships, so anything that must render *on top of an
 * open modal* has to beat it.
 */
export const MODAL_Z_INDEX = 12000000000000;

/**
 * For transient overlays launched from *inside* a modal — dropdown popovers,
 * bottom sheets, wheel pickers. Without this they portal to body at MUI's default
 * 1300 and get painted behind the modal, leaving the user unable to reach them.
 */
export const ABOVE_MODAL_Z_INDEX = MODAL_Z_INDEX + 1;
